import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=dfbe18b2&"
import script from "./Activate.vue?vue&type=script&lang=ts&"
export * from "./Activate.vue?vue&type=script&lang=ts&"
import style0 from "./Activate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports